import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, ListGroup, Image, Form, Button, Card } from 'react-bootstrap';
import { FaTrash, FaArrowLeft } from 'react-icons/fa';
import Message from '../components/Message';
import { addToCart, removeFromCart, saveShippingAddress } from '../slices/cartSlice';
import { isCableCategory, getCableQtyOptions } from '../constants';
import accounting from 'accounting-js';

const CartScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const { userInfo } = useSelector((state) => state.auth);

  const [address] = useState(userInfo?.companyAddress || '');
  const [city] = useState(userInfo?.city || '');
  const [state] = useState(userInfo?.state || '');
  const [receiver] = useState(userInfo?.companyName || '');
  const [email] = useState(userInfo?.email || '');
  const [phoneNumber] = useState(userInfo?.phoneNumber || '');

  const stat1 = useLocation();
 
  useEffect(() => {
    if (userInfo) {
      dispatch(saveShippingAddress({
        address, city, receiver, state, email, phoneNumber,
        companyState: userInfo?.companyState || '',
        companyCity: userInfo?.companyCity || '',
        taxNumber: userInfo?.taxNumber || '',
        taxState: userInfo?.taxState || '',
        idNumber: userInfo?.idNumber || '',
        name: userInfo?.name || '',
        surname: userInfo?.surname || '',
        companyName: userInfo?.companyName || '',
        companyAddress: userInfo?.companyAddress || '',
        isCompany: userInfo?.isCompany || ''
      }));
    }
  }, [cartItems, userInfo, dispatch, address, city, receiver, state, email, phoneNumber]);
  
  const addToCartHandler = (product, qty) => {
    dispatch(addToCart({ ...product, qty }));
  };

  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id));
  };

  const checkoutHandler = () => {
    userInfo ? navigate('/shipping') : navigate('/userfill');
  };

  const addToCartHandler1 = () => {
    if (cartItems.length === 0) {
      navigate('/');
    } else {
      (state && stat1.state?.post_id1) ? navigate(`/search/${stat1.state.post_id1}`) : navigate('/');
    }
  };

  return (
    <Row style={{ marginTop: '50px' }}>
      <Col xs={12} md={8}>
            <Button 
            variant="light" 
            className="btn btn-light my-3" 
            onClick={addToCartHandler1}
             style={{ 
              backgroundColor: '#2b2b2b',
              color: '#ffffff',
            marginTop: '50px',         // Siyah menü barı ile buton arasındaki mesafeyi artırır
            marginBottom: '20px',      // Buton ile "Alışveriş Sepeti" başlığı arasındaki mesafeyi ayarlar
            fontWeight: 'bold', 
            display: 'inline-flex', 
            alignItems: 'center', 
            gap: '8px',
            padding: '10px 18px',
            position: 'relative'
        }}
           onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'}
          >
            <FaArrowLeft /> Markete Dön
          </Button>
                <Card  className="border-0 shadow-sm rounded-4 overflow-hidden mb-4" 
            style={{ 
              borderTop: '4px solid #004488',
              marginTop: '-83px',    // Negatif margin ile aradaki dikey beyaz boşluk tamamen kapatıldı
              position: 'relative',
              zIndex: 0
            }}></Card>
          <Card>
            
                      <Card.Header className="text-white p-3 border-0" style={{ backgroundColor: '#66CCFF' }}>
                        <h4 className="m-0 fw-bold fs-5">Alışveriş Sepeti</h4>
                      </Card.Header>
        {cartItems.length === 0 ? ( 
          <Message>Sepetiniz Boş</Message>
        ) : (
          <ListGroup variant='flush'>
            {cartItems.map((item) => (
              <ListGroup.Item key={item._id}>
                <Row className="align-items-center gy-2">
                  <Col xs={3} sm={2} md={2}>
                    <Image src={item.image} alt={item.name} fluid rounded />
                  </Col>
                  <Col xs={9} sm={4} md={3}>
                    {/* REVIZYON: Link kaldırıldı, sadece düz metin (strong) olarak basıldı */}
                    <strong style={{ color: '#444' }}>{item.name}</strong>
                  </Col>
                  <Col xs={6} sm={2} md={2}>
                    {(item.priceShow || item.advertisementShow) ? (
                      <>
                        {item.discount > 0 && (
                          <div style={{ textDecoration: 'line-through', fontSize: '0.75rem', color: '#999' }}>
                            {accounting.formatMoney(item.price, { symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺
                          </div>
                        )}
                        <div style={{ fontWeight: 'bold' }}>
                          {accounting.formatMoney(item.price - (item.price * item.discount / 100), { symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺
                        </div>
                      </>
                    ) : 'Teklif İsteği'}
                  </Col>
                  <Col xs={4} sm={2} md={2}>
                    <Form.Control
                      as='select'
                      value={item.qty}
                      onChange={(e) => addToCartHandler(item, Number(e.target.value))}
                    >
                      {(() => {
                        // Kablo ürünlerinde kategoriye göre minimum ve artış adımı (katı)
                        // uygulanır - bkz. constants.js CABLE_CATEGORY_RULES.
                        const cableOptions = isCableCategory(item.category)
                          ? getCableQtyOptions(item.category, item.countInStock)
                          : null;
                        if (cableOptions) {
                          return cableOptions.map((n) => <option key={n} value={n}>{n}</option>);
                        }
                        return [...Array(item.countInStock).keys()].map((i) => {
                          const n = i + 1;
                          return <option key={n} value={n}>{n}</option>;
                        });
                      })()}
                    </Form.Control>
                  </Col>
                  <Col xs={2} sm={2} md={2}>
                    <Button
                      type='button'
                      variant='light'
                      onClick={() => removeFromCartHandler(item._id)}
                    >
                      <FaTrash />
                    </Button>

                  </Col>
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
        </Card>
      </Col>
      <Col xs={12} md={4} className="mt-4 mt-md-0">
        <Card>
          <Card.Header className="bg-dark text-white p-3 border-0"><h5 className="m-0 fw-bold">Sipariş Özeti</h5></Card.Header>
          <ListGroup variant='flush'>
            <ListGroup.Item>
              <h2 style={{ fontSize: '1.4rem' }}>
                Toplam ({cartItems.reduce((acc, item) => acc + item.qty, 0)}) Ürün
              </h2>
              <h5 className='text-center py-2'> 
                {cartItems.find(item => item.priceShow === false && item.advertisementShow === false) 
                  ? (<strong>Teklif verilecek</strong>) 
                  : (accounting.formatMoney(cartItems.reduce((acc, item) => acc + item.qty * (item.price - (item.price * item.discount / 100)), 0), { symbol: "", precision: 2, thousand: ".", decimal: "," }) + " ₺")
                } 
              </h5>
            </ListGroup.Item>
            
            {userInfo && cart.shippingAddress.name === ' ' && (
               <ListGroup.Item>
                  <Message variant='danger'>Profiliniz tamamlanmalı</Message>
               </ListGroup.Item>
            )}

            <ListGroup.Item>
              <Button
                type='button'
                className='w-100 btn-primary'
 type='submit' 
                className='w-100 border-0 fw-bold transition-all shadow-sm' 
                style={{ 
                  backgroundColor: '#2b2b2b', // Başlangıç rengi koyu gri
                  color: '#ffffff',
                  height: '46px',
                  borderRadius: '4px',
                  fontSize: '1.1rem',
                  transition: 'all 0.2s ease-in-out'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'} // Üzerine gelince açık mavi (#66CCFF)
                onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'} // Ayrılınca eski renk



                disabled={cartItems.length === 0 || (userInfo && cart.shippingAddress.name === ' ')}
                onClick={checkoutHandler}
              >
                {cartItems.find(item => item.priceShow === false && item.advertisementShow === false) 
                  ? 'Teklif İsteği Gönder' 
                  : 'Siparişe Devam Et'}
              </Button>

              {userInfo && cart.shippingAddress.name === ' ' && (
                <Button
                 type='submit' 
                className='w-100 border-0 fw-bold transition-all shadow-sm' 
                style={{ 
                  backgroundColor: '#2b2b2b', // Başlangıç rengi koyu gri
                  color: '#ffffff',
                  height: '46px',
                  borderRadius: '4px',
                  fontSize: '0.85rem',
                  transition: 'all 0.2s ease-in-out'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'} // Üzerine gelince açık mavi (#66CCFF)
                onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'} // Ayrılınca eski renk
              >
                  Profil Tamamla
                </Button>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Card>
      </Col>
    </Row>
  );
};

export default CartScreen;